import { Award } from "lucide-react";

export const SUPPORTER_BADGE_STYLES = {
  Oro: "bg-amber-400/15 text-amber-300 border-amber-400/40",
  Argento: "bg-slate-300/15 text-slate-200 border-slate-300/40",
  Bronzo: "bg-orange-500/15 text-orange-300 border-orange-500/40",
};

export function SupporterBadge({ badge, size = "sm", className = "" }) {
  if (!badge) return null;
  const base = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
  const icon = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <span
      data-testid={`supporter-badge-${badge}`}
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide rounded-full border ${base} ${SUPPORTER_BADGE_STYLES[badge] || ""} ${className}`}
    >
      <Award className={icon} /> {badge}
    </span>
  );
}
